import React from 'react'
import { useAudio } from 'react-use'

import PauseIcon from '@mui/icons-material/Pause'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import { Slider, Stack, Typography } from '@mui/material'

import IconButton from '@podcastsoundboard/ps-lib/components/AccessibleIconButton'

interface AudioPlayerProps {
  audioUrl: string
}

const AudioPlayer: React.FC<AudioPlayerProps> = ({ audioUrl }) => {
  const [audio, state, controls] = useAudio({
    src: audioUrl,
    autoPlay: false,
  })

  const handleChange = (_event: unknown, newValue: number | number[]) => {
    if (typeof newValue === 'number') {
      controls.seek(newValue)
    }
  }

  const handlePlayPause = async () => {
    if (state.playing) {
      await controls.pause()
    } else {
      await controls.play()
    }
  }

  return (
    <>
      {audio}

      <Stack
        direction="row"
        alignItems="center"
        justifyContent="flex-start"
        spacing={1}
      >
        <IconButton onClick={handlePlayPause} size="small">
          {state.playing ? (
            <PauseIcon sx={{ fontSize: '1.3rem' }} />
          ) : (
            <PlayArrowIcon sx={{ fontSize: '1.3rem' }} />
          )}
        </IconButton>
        <Slider
          aria-label="Audio progress"
          role="slider"
          aria-valuemin={0}
          aria-valuemax={state.duration ?? 100}
          aria-valuenow={state.time}
          title="Start of track fade-in duration in seconds"
          size="small"
          value={state.time}
          min={0}
          step={0.01}
          max={state.duration ?? 100}
          onChange={handleChange}
          sx={{ width: '150px' }}
        />
        <Typography variant="caption">
          {Number(state.time).toFixed(2)}s&nbsp;
          {state.duration && `/ ${Number(state.duration).toFixed(2)}`}s
        </Typography>
      </Stack>
    </>
  )
}

export default AudioPlayer
